import { Head } from "@inertiajs/react"

import TextLink from "@/components/text-link"
import AuthLayout from "@/layouts/auth-layout"
import { newMagicLinkPath } from "@/routes"

export default function MagicLinkSent() {
  return (
    <AuthLayout
      title="Check your email"
      description="We sent you a link to sign in"
    >
      <Head title="Check your email" />

      <div className="space-y-4 text-sm">
        <p>
          Open the email and click the sign-in link to finish. You can close
          this tab — you&apos;ll be signed in wherever you click the link.
        </p>

        <p className="text-muted-foreground">
          Didn&apos;t get it? Check your spam folder, or{" "}
          <TextLink href={newMagicLinkPath()}>request a new link</TextLink>.
        </p>
      </div>
    </AuthLayout>
  )
}
